import { OnboardingFlowV3, OnboardingFlowV4 } from "../../../model/Onboarding";
import { apiService } from "../../ApiService";

export const getSubscriptionFlow = (
  preshippingId?: string,
  plan?: string,
  version = "v3",
) => {
  const params: Record<string, string> = {
    version,
  };
  if (preshippingId) {
    params.preshipping_id = preshippingId;
  }
  if (plan) {
    params.plan = plan;
  }
  return apiService.get<OnboardingFlowV3 | OnboardingFlowV4>({
    path: `v1/subscription_flows`,
    params,
  });
};
